import React from 'react';

import {
   AttachmentsDownloadCell,
   AttachmentsPreviewCell,
   AttachmentsTable,
   componentsTranslationKeys,
   StyledMargin,
   TextView,
} from '@dreryk/react-components';

import { MedicalInformationAttachmentMarkOrUnmarkAsRemovedIcon } from './MedicalInformationAttachmentMarkOrUnmarkAsRemovedIcon';
import { MedicalInformationAttachmentStatus } from './MedicalInformationAttachmentStatus';
import { MedicalInformationPreview } from './MedicalInformationModal';

type MedicalInformationAttachmentsTableProps = {
   medicalInformation: MedicalInformationPreview;
};

export const MedicalInformationAttachmentsTable = (props: MedicalInformationAttachmentsTableProps): JSX.Element => {
   return (
      <TextView label={componentsTranslationKeys.attachments.attachments} testId={'attachments'}>
         <AttachmentsTable
            data={props.medicalInformation.attachments ?? []}
            testId={'attachments'}
            customOptions={{
               component: (attachment) => (
                  <>
                     {attachment.removed ? (
                        <StyledMargin right={32}>
                           <MedicalInformationAttachmentStatus />
                        </StyledMargin>
                     ) : (
                        <AttachmentsDownloadCell name={attachment.name} downloadUrl={attachment.downloadUrl} />
                     )}
                     <AttachmentsPreviewCell name={attachment.name} downloadUrl={attachment.downloadUrl} />

                     {props.medicalInformation.medicalInformationRemoved ? null : (
                        <MedicalInformationAttachmentMarkOrUnmarkAsRemovedIcon attachment={attachment} />
                     )}
                  </>
               ),
               width: 176,
            }}
         />
      </TextView>
   );
};
